import React from "react";
import Footer from "../components/Footer";
import { FooterNotes } from "../components/FooterNotes";
import Mobile from "../components/Mobile";
import Offers from "../components/Offers";
import Promotion from "../components/Promotion";
import Testimonial from "../components/Testimonial";

function Home({ subMenuList, setSubMenuindex }) {
  return (
    <div>
      <Promotion />
      <Offers />
      <Testimonial />
      <Mobile />
      <FooterNotes />
      <Footer />
    </div>
  );
}

export default Home;
